import React, { PureComponent } from "react";
import { get } from "lodash";
import { withApollo } from "react-apollo";
import InputAdornment from "@material-ui/core/InputAdornment";
import { InputNumberField } from "./";

class InputMontoField extends PureComponent {
  state = { currency: null };
  inputPropsCache = {};

  componentDidMount() {
    const { query, queryParams, path, currency } = this.props;
    if (currency) {
      this.setState({ currency });
    } else if (query) {
      this.fetchMoneda(query, queryParams, path);
    }
  }

  componentDidUpdate(prevProps) {
    const { query, queryParams, path, currency } = this.props;
    if (currency !== prevProps.currency) {
      this.setState({ currency });
    } else if (
      !currency &&
      query &&
      get(prevProps, "queryParams.idProveedor") !==
        get(this.props, "queryParams.idProveedor")
    ) {
      this.fetchMoneda(query, queryParams, path);
    }
  }

  async fetchMoneda(query, queryParams, path) {
    const { client } = this.props;
    await client
      .query({
        query: query,
        variables: { ...queryParams },
        fetchPolicy: "cache-first",
        errorPolicy: "all"
      })
      .then(res => {
        this.setState({
          currency: get(res, path, "")
        });
      });
  }

  render() {
    const { currency } = this.state;

    // Cachear InputProps para evitar nueva referencia en cada render
    if (!this._currencyCache || this._currencyCache !== currency) {
      this._currencyCache = currency;
      this.inputPropsCache = {
        startAdornment: (
          <InputAdornment position="start">{currency}</InputAdornment>
        )
      };
    }

    return (
      <InputNumberField {...this.props} InputProps={this.inputPropsCache} />
    );
  }
}

export default withApollo(InputMontoField);
